import { render, staticRenderFns } from "./EndorsementModal.vue?vue&type=template&id=fce9cbf4&scoped=true"
import script from "./EndorsementModal.vue?vue&type=script&lang=js"
export * from "./EndorsementModal.vue?vue&type=script&lang=js"
import style0 from "./EndorsementModal.vue?vue&type=style&index=0&id=fce9cbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce9cbf4",
  null
  
)

export default component.exports